/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
 var coverflow;

 function onApiReady() {
   console.log("api ready");
 }

 function onThumbChange(ev) {
   console.log("thumb id: " + ev.id);
 }

 function onCategoryChange(ev) {
   console.log("category id: " + ev.id);
 }

 function initLazyLoad() {
   jQuery("img.lazy").lazyload();
 }

 try {
   FWDRLS3DUtils.onReady(function() {
     coverflow = new FWDSimple3DCoverflow({

       //required settings
       coverflowHolderDivId: "myDiv",
       coverflowDataListDivId: "coverflowData",
       displayType: "fluidwidth",
       autoScale: "yes",
       coverflowWidth: 500,
       coverflowHeight: 538,
       mainFolderPath: "//localhost:3000/load/",
       skinPath: "skin_black",

       //main settings
       backgroundColor: "transparent",
       backgroundImagePath: "",
       backgroundRepeat: "repeat-x",
       showDisplay2DAlways: "no",
       coverflowStartPosition: "center",
       coverflowTopology: "dualsided",
       coverflowXRotation: 0,
       coverflowYRotation: 0,
       numberOfThumbnailsToDisplayLeftAndRight: "all",
       infiniteLoop: "no",
       rightClickContextMenu: "default",
       useDragAndSwipe: "no",
       fluidWidthZIndex: 1000,

       //thumbnail settings
       thumbnailWidth: 600,
       thumbnailHeight: 399,
       thumbnailXOffset3D: 86,
       thumbnailXSpace3D: 78,
       thumbnailZOffset3D: 200,
       thumbnailZSpace3D: 93,
       thumbnailYAngle3D: 70,
       thumbnailXOffset2D: 20,
       thumbnailXSpace2D: 30,
       thumbnailHoverOffset: 100,
       thumbnailBorderSize: 0,
       thumbnailBackgroundColor: "#FFFFFF",
       thumbnailBorderColor1: "#FFFFFF",
       thumbnailBorderColor2: "#FFFFFF",
       transparentImages: "no",
       thumbnailsAlignment: "center",
       maxNumberOfThumbnailsOnMobile: 13,
       showThumbnailsGradient: "yes",
       thumbnailGradientColor1: "rgba(0, 0, 0, 0)",
       thumbnailGradientColor2: "rgba(0, 0, 0, 1)",
       showText: "yes",
       textOffset: 10,
       showThumbnailBoxShadow: "yes",
       thumbnailBoxShadowCss: "0px 2px 2px #111111",
       showTooltip: "no",
       dynamicTooltip: "yes",
       showReflection: "yes",
       reflectionHeight: 60,
       reflectionDistance: 0,
       reflectionOpacity: .4,

       //controls settings
       slideshowDelay: 5000,
       autoplay: "no",
       disableNextAndPrevButtonsOnMobile: "no",
       controlsMaxWidth: 650,
       controlsPosition: "bottom",
       controlsOffset: 10,
       showLargeNextAndPrevCoverflowButtons: "no",
       largeNextAndPrevButtonsOffest: 20,
       showNextAndPrevCoverflowButtons: "no",
       showSlideshowButton: "no",
       showScrollbar: "no",
       showBulletsNavigation: "no",
       bulletsNormalColor: "#333333",
       bulletsSelectedColor: "#FFFFFF",
       bulletsNormalRadius: 5,
       bulletsSelectedRadius: 8,
       spaceBetweenBullets: 10,
       bulletsOffset: 14,
       disableScrollbarOnMobile: "yes",
       enableMouseWheelScroll: "yes",
       scrollbarHandlerWidth: 200,
       scrollbarTextColorNormal: "#000000",
       scrollbarTextColorSelected: "#000000",
       addKeyboardSupport: "yes",

       //categories settings
       showCategoriesMenu: "no",
       startAtCategory: 1,
       categoriesMenuMaxWidth: 700,
       categoriesMenuOffset: 25,
       categoryColorNormal: "#999999",
       categoryColorSelected: "#FFFFFF",

       //lightbox settings
       buttonsAlignment: "in",
       itemBoxShadow: "none",
       descriptionWindowAnimationType: "opacity",
       descriptionWindowPosition: "bottom",
       slideShowAutoPlay: "no",
       addKeyboardSupport: "yes",
       showCloseButton: "yes",
       showShareButton: "yes",
       showZoomButton: "yes",
       showSlideShowButton: "yes",
       showSlideShowAnimation: "yes",
       showNextAndPrevButtons: "yes",
       showNextAndPrevButtonsOnMobile: "yes",
       showDescriptionButton: "yes",
       showDescriptionByDefault: "no",
       videoShowFullScreenButton: "yes",
       videoAutoPlay: "yes",
       nextVideoOrAudioAutoPlay: "yes",
       videoLoop: "no",
       audioAutoPlay: "no",
       audioLoop: "no",
       backgroundOpacity: .9,
       descriptionWindowBackgroundOpacity: .95,
       buttonsHideDelay: 3,
       slideShowDelay: 4,
       defaultItemWidth: 640,
       defaultItemHeight: 480,
       itemOffsetHeight: 50,
       spaceBetweenButtons: 1,
       buttonsOffsetIn: 2,
       buttonsOffsetOut: 5,
       itemBorderSize: 0,
       itemBorderRadius: 0,
       itemBackgroundColor: "#333333",
       itemBorderColor: "#333333",
       lightBoxBackgroundColor: "#000000",
       descriptionWindowBackgroundColor: "#FFFFFF",
       videoPosterBackgroundColor: "#0099FF",
       videoControllerBackgroundColor: "#FFFFFF",
       audioControllerBackgroundColor: "#FFFFFF",
       timeColor: "#000000"
     });

     coverflow.addListener(FWDSimple3DCoverflow.IS_API_READY, onApiReady);
     coverflow.addListener(FWDSimple3DCoverflow.THUMB_CHANGE, onThumbChange);
     coverflow.addListener(FWDSimple3DCoverflow.CATEGORY_CHANGE, onCategoryChange);
   });
 } catch (e) {}


(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
